import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import {
  directedCastNames,
  withDirectedCastIds,
  withDirectedCastNames,
} from 'fym-shared/src/music24/directedCastNames';
import { useDirectedVideoContext } from './DirectedVideoContext';
import { castMessages } from './messages/castMessages';

export interface DirectedCastNames {
  /** The display name of each cast entry, by id. */
  names: ReadonlyMap<string, string>;
  /** A stored text as the artist reads it: each cast id is the name of its entry. */
  named: (text: string) => string;
  /** An edited text as it is stored: each shown name goes back to its cast id. */
  toIds: (text: string) => string;
}

/**
 * The names of the cast of the video on view (owner report 2026-10-18: the texts showed raw cast
 * ids). The label of an entry, the artist name for "me", else "Character N". The screens render
 * every text through `named`, so a rename shows in every old text; an editor stores through `toIds`.
 */
export function useDirectedCastNames(): DirectedCastNames {
  const intl = useIntl();
  const { video, song } = useDirectedVideoContext();
  return useMemo(() => {
    const names = directedCastNames(video.cast, song.artistName, (index) =>
      intl.formatMessage(castMessages.defaultName, { number: index + 1 })
    );
    return {
      names,
      named: (text: string) => withDirectedCastNames(text, names),
      toIds: (text: string) => withDirectedCastIds(text, names),
    };
  }, [intl, song.artistName, video.cast]);
}
